<template>
  <footer class="footer bg-light border-top py-3 mt-auto">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start">
          <p class="mb-0 text-muted">
            <i class="fas fa-copyright"></i>
            {{ currentYear }}
            <strong>翼鸿房产营销管家</strong>
            - 专业的客户关系管理解决方案
          </p>
        </div>
        <div class="col-md-6 text-center text-md-end">
          <p class="mb-0 text-muted">
            <small>
              <i class="fas fa-code"></i>
              <span ref="techStack" class="tech-stack-label">
                基于 Vue.js + Flask 技术栈
              </span>
              <span class="mx-2">|</span>
              <i class="fas fa-shield-alt"></i>
              安全可靠
            </small>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { Popover } from 'bootstrap'

export default {
  name: 'FooterComponent',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())
    const techStack = ref(null)
    let popover = null

    onMounted(() => {
      if (techStack.value) {
        popover = new Popover(techStack.value, {
          content: '由深圳数海涟漪科技有限公司开发',
          trigger: 'hover',
          placement: 'top',
          delay: { show: 3000, hide: 100 }
        })
      }
    })

    onUnmounted(() => {
      if (popover) {
        popover.dispose()
      }
    })

    return {
      currentYear,
      techStack
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%);
  border-top-color: #e9ecef !important;
}

.footer p {
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 400;
}

.footer strong {
  color: #495057;
}

.tech-stack-label {
  cursor: default;
}
</style>